/* eslint-disable no-console */
import * as THREE from 'three';
import { SupportsGroup } from './SupportsGrpoup';
import { getPlaneIntersected } from '../../js';
import {
  ConstructorSupportsProps,
  LineObjType,
  LineObjTypeItemsType,
  MaxMinPointsProps,
} from './types';
import { LineIntersType, RoomObjectSurface, SupportsGroupType } from '../../types';
import { addSupportMesh, getParamsBetweenTwoPoints } from './helpers';

interface PropsPleaseType {
  superStart: THREE.Vector3;
  p3: THREE.Vector3;
  prevPoint: THREE.Vector3;
  lineObj: LineObjTypeItemsType;
}
interface PlaceIntermediateType {
  superStart?: THREE.Vector3;
  end: THREE.Vector3;
  start: THREE.Vector3;
}
// const PLANK_LENGTH = 6;
export class SupportGroupTimber extends SupportsGroup implements SupportsGroupType {
  private directionTimber = new THREE.Vector3(1, 0, 0);
  private directionPlank = new THREE.Vector3(0, 0, -1);
  private middlePointsContour: Array<THREE.Vector3> = [];
  private lineMaterial = new THREE.LineBasicMaterial({ color: '#ff00ff' });
  private maxLengthPlank = 0;
  constructor({ ...props }: ConstructorSupportsProps) {
    super(props);
  }

  createBottomPlaneIntersected() {
    this.directionTimber = new THREE.Vector3(1, 0, 0);
    this.directionPlank = new THREE.Vector3(0, 0, -1);
    this.middlePointsContour = this.getScaleContourFigure(SupportsGroup.radiusBaseSupport);
    this.lineMaterial = new THREE.LineBasicMaterial({ color: '#00ff00', linewidth: 2 });

    const { p0, p1, p2, p3 } = this.getMaxMinPointsContour();
    const angleRad = THREE.MathUtils.degToRad(this?.directionBuildDeg || 0);
    const _p0 = p0.clone();
    const _p1 = p1.clone();
    const _p2 = p2.clone();
    const _p3 = p3.clone();

    if (angleRad <= Math.PI / 2) {
      const direct = new THREE.Vector3(1, 0, 0);
      direct.applyAxisAngle(new THREE.Vector3(0, 1, 0), angleRad).normalize();
      this.directionTimber.copy(direct);
      this.directionPlank
        .copy(direct.clone().applyAxisAngle(new THREE.Vector3(0, 1, 0), Math.PI / 2))
        .normalize();

      const gipHorizontal = p0.distanceTo(p1);
      const gipVertical = p0.distanceTo(p3);
      const catMin = gipVertical * Math.sin(angleRad);
      const catMax = gipHorizontal * Math.cos(angleRad);
      _p0.copy(p0.clone().add(direct.clone().negate().multiplyScalar(catMin)));
      _p1.copy(p0.clone().add(direct.clone().multiplyScalar(catMax)));

      _p2.copy(p2.clone().add(direct.clone().multiplyScalar(catMin)));
      _p3.copy(p2.clone().add(direct.clone().negate().multiplyScalar(catMax)));
    }

    this.planeIntersBottom = getPlaneIntersected([_p0, _p1, _p2, _p3]);
    this.maxLengthPlank = _p3.distanceTo(_p0);
    // this.add(this.planeIntersBottom);
  }
  protected createRoomsMeshesInters(roomsObjects?: RoomObjectSurface) {
    super.createRoomsMeshesInters(roomsObjects);
  }
  protected createSupportObjects() {
    if (this.planeIntersBottom) {
      const p3 = (this.planeIntersBottom.geometry as THREE.Geometry).vertices[3].clone();
      const lineObj: LineObjType = this.createMiddleLinesInters();
      const lineObjParallel: Array<LineObjTypeItemsType> = [];
      for (const lineObjKey in lineObj) {
        if (Math.sin(lineObj[lineObjKey].angleBasicDirect) < 0.001) {
          lineObjParallel.push(lineObj[lineObjKey]);
        }
      }
      // console.log(lineObjParallel);

      this.getPointsIntersectedLinePlank();
      const dirPlank = this.directionPlank.clone().multiplyScalar(this.offsetZ);
      let nextPoint = p3
        .add(this.directionTimber.clone().multiplyScalar(SupportsGroup.radiusBaseSupport))
        .setY(0)
        .clone();
      const startPoint = p3.clone();

      let isRunPlank = true;
      let isOffsetTimber = false;

      this.getPointsIntersectedLinePlank();

      // console.log(this.maxLengthPlank)
      /*let actionAddTwoSupport = 0;
      const dataTwoSupport: Array<number> = [];
      if (this.maxLengthPlank > PLANK_LENGTH) {
        const divider = this.maxLengthPlank - PLANK_LENGTH;
        if (divider < 2) {
          dataTwoSupport.push(2, this.maxLengthPlank - 2);
        } else {
          // const length = (this.maxLengthPlank - PLANK_LENGTH) / this.offsetZ;
          dataTwoSupport.push(
            parseFloat((this.maxLengthPlank - PLANK_LENGTH).toFixed(2)),
            PLANK_LENGTH
          );
        }
      }*/

      while (isRunPlank) {
        // const currenDist = parseFloat((startPoint.distanceTo(p3) + this.offsetZ).toFixed(2));
        // console.log(currenDist);

        const vertices = this.getPointsIntersectedLineTimber(nextPoint, lineObj);
        // console.log(vertices);
        if (vertices.length && vertices.length % 2 === 0) {
          const div = vertices.length / 2;
          const superStart = nextPoint.clone();
          if (isOffsetTimber) {
            superStart.add(
              this.directionTimber
                .clone()
                .negate()
                .multiplyScalar(this.offsetX / 2)
            );
          }
          for (let i = 0; i < div; i++) {
            this.placeIntermediateSupportsForTimber({
              superStart,
              start: vertices[i * 2],
              end: vertices[1 + i * 2],
            });
          }
        }

        /*if ((dataTwoSupport.length && currenDist >= dataTwoSupport[0]) || actionAddTwoSupport > 0) {
          if (actionAddTwoSupport === 0) {
            actionAddTwoSupport = 3;
            p3.add(dirPlank).setY(0);
            dataTwoSupport.shift();
          }

          if (actionAddTwoSupport === 3) {
            nextPoint = p3
              .clone()
              .add(
                this.directionPlank.clone().multiplyScalar(SupportsGroup.radiusBaseSupport * 0.7)
              )
              .setY(0);
            actionAddTwoSupport -= 1;
          } //
          else if (actionAddTwoSupport === 2) {
            nextPoint = p3
              .clone()
              .add(
                this.directionPlank
                  .clone()
                  .negate()
                  .multiplyScalar(SupportsGroup.radiusBaseSupport * 0.7)
              )
              .setY(0);
            actionAddTwoSupport -= 1;
          } else if (actionAddTwoSupport === 1) {
            nextPoint = p3.add(dirPlank).setY(0).clone();
            actionAddTwoSupport -= 1;
          }
        } //
        else {
          nextPoint = p3.add(dirPlank).setY(0).clone();
        }*/

        const prevPoint = nextPoint.clone();
        nextPoint = p3.add(dirPlank).setY(0).clone();

        SupportsGroup.raycaster.set(nextPoint, SupportsGroup.directBottom);
        const intersect = SupportsGroup.raycaster.intersectObject(this.planeIntersBottom);
        isRunPlank = intersect.length > 0;
        if (isRunPlank) {
          lineObjParallel.forEach(item => {
            this.defineDistanceToParallelLines({
              p3,
              prevPoint,
              superStart: nextPoint,
              lineObj: item,
            });
          });
        }
        isOffsetTimber = !isOffsetTimber;
      }

      this.placeIntermediateSupportsForContourRoom(lineObj);
    }
  }
  private defineDistanceToParallelLines({
    p3,
    prevPoint = new THREE.Vector3(),
    superStart = new THREE.Vector3(),
    lineObj,
  }: PropsPleaseType) {
    const dirStart = lineObj.start.clone().sub(superStart);
    const distStart = lineObj.start.distanceTo(superStart);
    const angleStart = dirStart.angleTo(this.directionTimber);
    const resStart = distStart * Math.sin(angleStart);

    if (resStart < SupportsGroup.radiusBaseSupport * 2) {
      const vectorStart = lineObj.start.distanceTo(prevPoint);
      const vectorSuper = superStart?.distanceTo(prevPoint);

      if (vectorSuper >= vectorStart) {
        superStart.add(this.directionPlank.clone().negate().multiplyScalar(resStart));
        lineObj.isPlaceIntermediate = false;
      } else {
        superStart.add(
          this.directionPlank
            .clone()
            .negate()
            .multiplyScalar(SupportsGroup.radiusBaseSupport * 2 - resStart)
        );
      }
      p3.copy(superStart);
      // console.log(superStart, start, end);
      // console.log('resStart', resStart);
    }
  }
  protected getMaxMinPointsContour(): MaxMinPointsProps {
    const pointsX = this.contour.map(point => point.x);
    const pointsZ = this.contour.map(point => point.z);
    const minX = Math.min(...pointsX);
    const minZ = Math.min(...pointsZ);
    const maxX = Math.max(...pointsX);
    const maxZ = Math.max(...pointsZ);
    const p0 = new THREE.Vector3(minX, 0, minZ);
    const p1 = new THREE.Vector3(maxX, 0, minZ);
    const p2 = new THREE.Vector3(maxX, 0, maxZ);
    const p3 = new THREE.Vector3(minX, 0, maxZ);

    return { p0, p1, p2, p3 };
  }
  private getPointsIntersectedLineTimber(
    origin: THREE.Vector3,
    lineObj: LineObjType
  ): Array<THREE.Vector3> {
    const pointInters: Array<THREE.Vector3> = [];
    const pointNoChange: Array<THREE.Vector3> = [];
    const keysLines = Object.keys(lineObj);

    for (let i = 0; i < keysLines.length; i++) {
      const line = lineObj[keysLines[i]];

      const pointIntersLine = new THREE.Vector3();
      const lineDirect = line.end.clone().sub(line.start).normalize();
      const angle = lineDirect.angleTo(this.directionTimber);
      // console.log(Math.sin(angle));
      // console.log(THREE.MathUtils.radToDeg(angle));

      if (Math.sin(angle) < 0.001) {
        continue;
      } //

      SupportsGroup.ray.set(
        origin.clone().add(this.directionTimber.clone().negate().multiplyScalar(0.5)),
        this.directionTimber
      );
      const distPointRay = SupportsGroup.ray.distanceSqToSegment(
        line.start,
        line.end,
        undefined,
        pointIntersLine
      );

      if (distPointRay < 0.00001) {
        const out = lineDirect.clone().cross(this.directionTimber).getComponent(1);
        pointNoChange.push(pointIntersLine.clone());

        if (angle < Math.PI / 2 - 0.01 || angle > Math.PI / 2 + 0.01) {
          const isNear = this.isNearPointsContour(pointIntersLine);
          if (!isNear) {
            line.planePoints.push(pointIntersLine.clone());
            addSupportMesh(this, pointIntersLine);
          }

          // const distMiddle = SupportsGroup.radiusBaseSupport / Math.sin(angle);
          const distMiddle = SupportsGroup.radiusBaseSupport * 2;
          if (out > 0) {
            pointIntersLine.add(this.directionTimber.clone().negate().multiplyScalar(distMiddle));
          } else {
            pointIntersLine.add(this.directionTimber.clone().multiplyScalar(distMiddle));
          }
        }
        pointInters.push(pointIntersLine);
      }
    }

    pointInters.sort((a, b) => a.distanceTo(origin) - b.distanceTo(origin));
    pointNoChange.sort((a, b) => a.distanceTo(origin) - b.distanceTo(origin));
    if (pointInters.length && pointInters.length % 2 === 0) {
      const div = pointInters.length / 2;
      for (let i = 0; i < div; i++) {
        const start = pointInters[i * 2];
        const startNo = pointNoChange[i * 2];
        const end = pointInters[1 + i * 2];
        const endNo = pointNoChange[1 + i * 2];

        if (startNo.distanceTo(endNo) >= SupportsGroup.radiusBaseSupport * 6) {
          addSupportMesh(this, start);
          addSupportMesh(this, end);
          this.addTimberLine({ start, end });
        } else {
          const pointObject = this.placementSupportsCorners({
            start: startNo,
            end: endNo,
          });
          if (pointObject) {
            addSupportMesh(this, pointObject.start);
            addSupportMesh(this, pointObject.end);
            this.addTimberLine({ start: pointObject.start, end: pointObject.end });
            pointInters[i * 2].copy(pointObject.start);
            pointInters[1 + i * 2].copy(pointObject.end);
          }
        }
      }
    } //
    else if (pointInters.length === 3) {
      addSupportMesh(this, pointInters[0]);
      addSupportMesh(this, pointInters[2]);
      this.addTimberLine({ start: pointInters[0], end: pointInters[2] });
      pointInters.splice(1, 1);
    }

    return pointInters;
  }
  private placementSupportsCorners({ start, end }: LineIntersType): LineIntersType | undefined {
    let minDist = Infinity;
    const cornerPoint = new THREE.Vector3();
    this.middlePointsContour.forEach(item => {
      const dist = start.distanceTo(item);
      if (dist < minDist) {
        minDist = dist;
        cornerPoint.copy(item);
      }
    });
    const minDistance = Math.min(cornerPoint.distanceTo(start), cornerPoint.distanceTo(end));
    if (minDistance < SupportsGroup.radiusBaseSupport / 2) {
      return;
    }
    const directStart = cornerPoint.clone().sub(start).normalize();
    const distStart = cornerPoint.distanceTo(start);
    const directEnd = cornerPoint.clone().sub(end).normalize();
    const angleStart = directStart.angleTo(this.directionTimber);
    const angleEnd = directEnd.angleTo(this.directionTimber);

    const catStart = distStart * Math.sin(angleStart);

    const newCat = this.offsetZ + catStart - SupportsGroup.radiusBaseSupport * 2;
    const gipStart = newCat / Math.sin(angleStart);
    const gipEnd = newCat / Math.sin(angleEnd);

    const newPointStart = cornerPoint
      .clone()
      .add(directStart.clone().negate().multiplyScalar(gipStart))
      .add(this.directionTimber.clone().multiplyScalar(SupportsGroup.radiusBaseSupport * 2));
    const newPointEnd = cornerPoint
      .clone()
      .add(directEnd.clone().negate().multiplyScalar(gipEnd))
      .add(
        this.directionTimber
          .clone()
          .negate()
          .multiplyScalar(SupportsGroup.radiusBaseSupport * 2)
      );
    // getDumObjects(newPointStart, 'red');
    // getDumObjects(newPointEnd, 'green');
    return {
      start: newPointStart,
      end: newPointEnd,
    };
  }
  private getPointsIntersectedLinePlank() {
    const middlePointsContour = this.getScaleContourFigure(SupportsGroup.radiusBaseSupport);
    for (let i = 0; i < middlePointsContour.length; i++) {
      addSupportMesh(this, middlePointsContour[i]);
      const p0 = middlePointsContour[i].clone();
      const p1 = new THREE.Vector3();
      if (i === middlePointsContour.length - 1) {
        p1.copy(middlePointsContour[0].clone());
      } else {
        p1.copy(middlePointsContour[i + 1].clone());
      }

      const dir = p1.clone().sub(p0).normalize();
      const anglePlank = dir.angleTo(this.directionPlank);
      if (anglePlank === 0 || anglePlank === Math.PI) {
        // continue;
      } else {
        this.addTimberLine({ start: p0, end: p1 });
      }
    }
  }
  private getScaleContourFigure(offset = SupportsGroup.radiusBaseSupport): Array<THREE.Vector3> {
    const middlePointsContour = [];
    for (let i = 0; i < this.contour.length; i++) {
      let item;
      let itemNext;
      let itemPrev;

      if (i === 0) {
        itemPrev = this.contour[this.contour.length - 1].clone().setY(0);
        item = this.contour[i].clone().setY(0);
        itemNext = this.contour[i + 1].clone().setY(0);
      } //
      else if (i === this.contour.length - 1) {
        itemPrev = this.contour[i - 1].clone().setY(0);
        item = this.contour[i].clone().setY(0);
        itemNext = this.contour[0].clone().setY(0);
      } //
      else {
        itemPrev = this.contour[i - 1].clone().setY(0);
        item = this.contour[i].clone().setY(0);
        itemNext = this.contour[i + 1].clone().setY(0);
      }
      const dir = itemPrev.clone().sub(item).normalize();
      const dirNext = itemNext.clone().sub(item).normalize();

      const middleVec = dir.clone().add(dirNext).normalize();
      const y = dir.clone().cross(dirNext).getComponent(1);
      if (y < 0) {
        middleVec.negate();
      }

      const angle = dirNext.angleTo(middleVec);
      let distMiddle = offset;
      if (angle < Math.PI) {
        distMiddle = offset / Math.sin(angle);
      }

      // console.log(i, THREE.MathUtils.radToDeg(angle))
      // const an = middleVec.angleTo(this.directionTimber);
      // const cross =  middleVec.clone().cross(this.directionTimber).getComponent(1);
      // let _angle  = an;
      // if (cross < 0) {
      //   _angle = Math.PI - an;
      // }
      // if (y >= 0 && _angle < Math.PI / 2) {
      //   console.log(i, THREE.MathUtils.radToDeg(_angle));
      // }

      const nextPoint = item.clone().add(middleVec.clone().multiplyScalar(distMiddle));
      middlePointsContour.push(nextPoint);
    }
    return middlePointsContour;
  }
  private isNearPointsContour(point: THREE.Vector3): boolean {
    let res = false;
    for (let i = 0; i < this.middlePointsContour.length; i++) {
      const item = this.middlePointsContour[i];
      const dist = item.distanceTo(point);
      if (dist < SupportsGroup.radiusBaseSupport) {
        res = true;
        break;
      }
    }
    return res;
  }
  private addTimberLine({ start, end }: LineIntersType) {
    const geometry = new THREE.Geometry().setFromPoints([start, end]);
    const line = new THREE.Line(geometry, this.lineMaterial);
    this.add(line);
  }
  private placeIntermediateSupportsForTimber({ superStart, start, end }: PlaceIntermediateType) {
    const dist = start.distanceTo(end);
    if (dist < this.offsetX) {
      return;
    }

    const direct = end.clone().sub(start).normalize();

    const quantity = Math.trunc(dist / this.offsetX);
    if (quantity === 1 && dist < this.offsetX + SupportsGroup.radiusBaseSupport * 2) {
      const pos = end.clone().add(
        direct
          .clone()
          .negate()
          .multiplyScalar(SupportsGroup.radiusBaseSupport * 2)
      );
      addSupportMesh(this, pos);
      return;
    }

    const midPoint = start.clone();
    if (superStart) {
      const superDist = superStart.distanceTo(
        start.clone().add(direct.clone().multiplyScalar(SupportsGroup.radiusBaseSupport))
      );
      const supQuantity = Math.ceil(superDist / this.offsetX);
      const lastDist = supQuantity * this.offsetX;
      midPoint.copy(superStart.clone().add(direct.clone().multiplyScalar(lastDist)));

      const startDist = start.distanceTo(midPoint);
      if (startDist < SupportsGroup.radiusBaseSupport * 2) {
        const nearPoint = start
          .clone()
          .add(direct.clone().multiplyScalar(SupportsGroup.radiusBaseSupport * 2));
        addSupportMesh(this, nearPoint);
      } else {
        addSupportMesh(this, midPoint);
      }
    }
    let lastDistance = midPoint.distanceTo(end);
    while (lastDistance > this.offsetX) {
      midPoint.add(direct.clone().multiplyScalar(this.offsetX));
      lastDistance = midPoint.distanceTo(end);
      if (lastDistance < SupportsGroup.radiusBaseSupport * 2) {
        midPoint.copy(
          end.clone().add(
            direct
              .clone()
              .negate()
              .multiplyScalar(SupportsGroup.radiusBaseSupport * 2)
          )
        );
      }

      // if (lineObjParallel?.length) {
      //   for (let i = 0; i < lineObjParallel.length; i++) {
      //     const line = lineObjParallel[i];
      //
      //     const pointIntersLine = new THREE.Vector3();
      //     SupportsGroup.ray.set(midPoint, this.directionPlank);
      //     const distPointRay = SupportsGroup.ray.distanceSqToSegment(
      //       line.start,
      //       line.end,
      //       undefined,
      //       pointIntersLine
      //     );
      //     if (distPointRay < 0.00001) {
      //       const dist = midPoint.distanceTo(pointIntersLine);
      //       if (dist < SupportsGroup.radiusBaseSupport * 2) {
      //         console.log(dist);
      //       }
      //     }
      //
      //   }
      // }

      addSupportMesh(this, midPoint);
    }
  }
  private placeIntermediateSupportsForContourRoom(lineObj: LineObjType) {
    for (const key in lineObj) {
      const { direction } = getParamsBetweenTwoPoints(lineObj[key].start, lineObj[key].end);
      const anglePlank = direction.angleTo(this.directionPlank);
      if (!lineObj[key].isPlaceIntermediate || anglePlank === 0 || anglePlank === Math.PI) {
        continue;
      }

      if (lineObj[key].planePoints.length) {
        lineObj[key].planePoints.sort(
          (a, b) => lineObj[key].start.distanceTo(a) - lineObj[key].start.distanceTo(b)
        );
        lineObj[key].planePoints.unshift(lineObj[key].start);
        lineObj[key].planePoints.push(lineObj[key].end);
        for (let i = 0; i < lineObj[key].planePoints.length - 1; i++) {
          const start = lineObj[key].planePoints[i];
          const end = lineObj[key].planePoints[i + 1];

          const dist = start.distanceTo(end);
          const quantity = Math.trunc(dist / this.offsetX);
          if (quantity === 1) {
            const pos = start.clone().add(direction.clone().multiplyScalar(dist / 2));
            addSupportMesh(this, pos);
          } else if (quantity > 1) {
            const offset = dist / (quantity + 1);
            const pos = start.clone();
            for (let j = 0; j < quantity; j++) {
              pos.add(direction.clone().multiplyScalar(offset));
              addSupportMesh(this, pos);
            }
          }
        }
      } //
      else {
        this.placeIntermediateSupportsForTimber({
          start: lineObj[key].start,
          end: lineObj[key].end,
        });
      }
    }
  }
  private createMiddleLinesInters(): LineObjType {
    const lineObj: LineObjType = {};
    for (let i = 0; i < this.middlePointsContour.length; i++) {
      const line = {
        start: this.middlePointsContour[i].clone(),
        end: new THREE.Vector3(),
      };
      let keyLine;
      if (i === this.middlePointsContour.length - 1) {
        line.end.copy(this.middlePointsContour[0].clone());
        keyLine = `${i}0`;
      } else {
        line.end.copy(this.middlePointsContour[i + 1].clone());
        keyLine = `${i}${i + 1}`;
      }

      const directLine = line.end.clone().sub(line.start).normalize();

      if (!Object.hasOwn(lineObj, keyLine)) {
        lineObj[keyLine] = {
          start: line.start,
          end: line.end,
          planePoints: [],
          directLine,
          angleBasicDirect: directLine.angleTo(this.directionTimber),
          isPlaceIntermediate: true,
        };
      }
    }
    return lineObj;
  }
}
